import React, { useEffect, useState } from "react";
import { useStyles } from "../AssetNonTitled/AssetNonTitledFormStyles";
import {
  Grid,
  Select,
  FormControl,
  MenuItem,
  InputLabel,
  TextField
} from "@material-ui/core";
import { actions } from "../AssetReducer";
import useAssetProvider from "../useAssetProvider";

export default function VinFoundDetails({ asset, conditions, dispatch, classId, loadConfigChoices, setAssetConfig }) {
  const classes = useStyles();
  const {
    getPDConfig,
    getPDValue,
    getEWConfig,
    getEWValue,
  } = useAssetProvider();

  const [categoryChoices, setCategoryChoices] = useState([]);
  const [makeChoices, setMakeChoices] = useState([]);
  const [modelChoices, setModelChoices] = useState([]);
  const [configChoices, setConfigChoices] = useState([]);

  const getCategoryChoices = async (overrideYear) => {
    try {
      const response = await getPDConfig({
        year: overrideYear,
        classid: classId,
      });
      if (response.length) {
        setCategoryChoices(response)
      }
    } catch (error) {
      console.error(error);
    }
  }

  const getMakeChoices = async (overrideYear, categoryId) => {
    try {
      // Load the dropdown for Make choices
      const responseMake = await getPDConfig({
        year: overrideYear,
        classid: classId,
        categoryId: categoryId,
      });
      if (responseMake.length) {
        setMakeChoices(responseMake);
      }
    } catch (error) {
      console.error(error);
    }
  }

  const getModelChoices = async (overrideYear, categoryId, make) => {
    try {
      // Load the dropdown for Make choices
      const responseModel = await getPDConfig({
        year: overrideYear,
        classid: classId,
        categoryId: categoryId,
        manufacturer: make,
      });
      if (responseModel.length) {
        setModelChoices(responseModel);
      }
    } catch (error) {
      console.error(error);
    }
  }

  const getConfigChoices = async (modelName) => {
    try {
      const response = await getPDConfig({
        year: asset.override_year,
        classid: classId,
        categoryId: asset.pd_override_categoryid,
        manufacturer: asset.override_make,
        modelName: modelName,
      });
      if (response.length) {
        const configurations = [];
        await Promise.all(
          response.map(async (item) => {
            const config = await getPDConfig({
              configurationId: item.configurationId,
            });
            configurations.push(config);
          })
        );

        const updatedConfigs = [];
        configurations.map((item) => {
          const specs = item.specs;
          const specification = {};
          specs.map((spec) => {
            specification[spec.specName] = spec.specValue;
          });
          updatedConfigs.push({ ...item, specs: specification });
        });
        setConfigChoices(updatedConfigs);
      }
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    if (asset) {

      //Load Category Choices
      getCategoryChoices(asset.override_year);

      // Load the dropdown for Make choices
      getMakeChoices(asset.override_year, asset.pd_override_categoryid);

      // Load the dropdown for Model choices
      getModelChoices(asset.override_year, asset.pd_override_categoryid, asset.override_make);

      //Load Type Description Dropdown
      getConfigChoices(asset.override_model);
    }
  }, []);

  return (
    <Grid item xs={12}>
      <Grid item xs={12}>
        <FormControl className={classes.formControl} style={{ width: "100%" }}>
          <InputLabel id="override-year-label">Override Year</InputLabel>
          <Select
            style={{ width: "100%" }}
            id="override-year-select"
            labelId="override-year-label"
            value={asset.override_year || ""}
            disabled={asset?.override_vin_found}
            onChange={(e) => {
              dispatch({
                type: actions.OVERRIDE_YEAR,
                payload: e.target.value,
              });
              getCategoryChoices(e.target.value);

            }}>
            {conditions.yearChoices &&
              conditions.yearChoices.map((year) => (
                <MenuItem key={year} value={year}>
                  {year}
                </MenuItem>
              ))}
          </Select>
        </FormControl>
      </Grid>
      <Grid item xs={12}>
        {asset?.override_vin_found ? (
          <TextField
            style={{ width: "100%" }}
            label="Override Category"
            id="override-category"
            type="text"
            margin="normal"
            value={asset?.pd_override_category}
            disabled
            name="Override Category"
            onChange={(e) =>
              dispatch({
                type: actions.pd_override_category,
                payload: e.target.value

              })
            }
          />
        ) : (
          <FormControl className={classes.formControl} style={{ width: "100%" }}>
            <InputLabel id="override-category-label">Override Category</InputLabel>
            <Select
              style={{ width: "100%" }}
              id="override-category-select"
              labelId="override-category-label"
              value={asset.pd_override_category || ""}>
              {categoryChoices &&
                categoryChoices.map((category) => (
                  <MenuItem key={category.categoryId} value={category.categoryName} onClick={() => {
                    dispatch({
                      type: actions.PD_OVERRIDE_CATEGORY,
                      payload: {
                        categoryId: category.categoryId,
                        categoryName: category.categoryName,
                      },
                    });
                    getMakeChoices(asset.override_year, category.categoryId);
                  }}
                  >
                    {category.categoryName}
                  </MenuItem>
                ))}
            </Select>
          </FormControl>)}
      </Grid>
      <Grid item xs={12}>
        {asset?.override_vin_found ? (
          <TextField
            style={{ width: "100%" }}
            label="Override Make"
            id="override-make"
            type="text"
            margin="normal"
            disabled
            value={asset?.override_make}
            name="Override Make"
            onChange={(e) =>
              dispatch({
                type: actions.override_make,
                payload: e.target.value

              })
            }
          />
        ) : (
          <FormControl className={classes.formControl} style={{ width: "100%" }}>
            <InputLabel id="override-make-label">Override Make</InputLabel>
            <Select
              style={{ width: "100%" }}
              id="override-make-select"
              labelId="override-make-label"
              value={asset.override_make || ""}
              onChange={(e) => {
                dispatch({
                  type: actions.OVERRIDE_MAKE,
                  payload: e.target.value,
                });
                getModelChoices(asset.override_year, asset.pd_override_categoryid, e.target.value);
              }}>
              {makeChoices &&
                makeChoices.map((make) => (
                  <MenuItem key={make.manufacturerId} value={make.manufacturerName}>
                    {make.manufacturerName}
                  </MenuItem>
                ))}
            </Select>
          </FormControl>)}
      </Grid>
      <Grid item xs={12}>
        {asset?.override_vin_found ? (
          <TextField
            style={{ width: "100%" }}
            label="Override Model"
            id="override-model"
            type="text"
            margin="normal"
            disabled
            value={asset?.override_model}
            name="Override Model"
            onChange={(e) =>
              dispatch({
                type: actions.override_model,
                payload: e.target.value

              })
            }
          />
        ) : (
          <FormControl className={classes.formControl} style={{ width: "100%" }}>
            <InputLabel id="override-model-label">Override Model</InputLabel>
            <Select
              style={{ width: "100%" }}
              id="override-model-select"
              labelId="override-model-label"
              value={asset.override_model || ""}
              onChange={(e) => {
                dispatch({
                  type: actions.OVERRIDE_MODEL,
                  payload: e.target.value,
                });
                getConfigChoices(e.target.value);
              }}>
              {modelChoices &&
                modelChoices.map((model) => (
                  <MenuItem key={model.modelId} value={model.modelName}>
                    {model.modelName}
                  </MenuItem>
                ))}
            </Select>
          </FormControl>
        )}
      </Grid>
      <Grid item xs={12}>
        <FormControl className={classes.formControl} style={{ width: "100%" }}>
          <InputLabel id="override-config-label">Override Description</InputLabel>
          <Select
            style={{ width: "100%" }}
            id="override-config-select"
            labelId="override-config-label"
            value={asset.override_description || ""}>
            {configChoices &&
              configChoices.map((config) => (
                <MenuItem key={config.configurationId} value={config.specs.description || config.specs.modelDescription} onClick={() => dispatch({
                  type: actions.OVERRIDE_DESCRIPTION,
                  payload: {
                    configurationId: config.configurationId,
                    override_des: config.specs.description || config.specs.modelDescription
                  },
                })
                } >
                  {config.specs.description || config.specs.modelDescription}
                </MenuItem>
              ))}
          </Select>
        </FormControl>
      </Grid>
      <Grid item xs={12}>
        <FormControl className={classes.formControl} style={{ width: "100%" }}>
          <InputLabel id="override-condition-label">Override Condition</InputLabel>
          <Select
            style={{ width: "100%" }}
            id="override-condition-select"
            labelId="override-condition-label"
            value={asset.override_condition || ""}
            onChange={(e) => {
              dispatch({
                type: actions.OVERRIDE_CONDITION,
                payload: e.target.value,
              });
            }}>
            <MenuItem value="New">New</MenuItem>
            <MenuItem value="Used">Used</MenuItem>
          </Select>
        </FormControl>
      </Grid>
      {
        asset?.type.includes("Truck") &&
        <Grid item xs={12}>
          <TextField
            style={{ width: "100%" }}
            id="vehicle-mileage"
            label="Vehicle Mileage"
            value={asset?.override_mileage}
            type="text"
            margin="normal"
            inputProps={{
              maxLength: 7,
            }}
            onChange={(e) =>
              dispatch({
                type: actions.OVERRIDE_MILEAGE,
                payload: e.target.value.replace(/[\D,-]/g, ''),
              })
            }
          />
        </Grid>
      }
      {
        asset?.type.includes("Trailer") &&
        <Grid item xs={12}>
          <TextField
            style={{ width: "100%" }}
            id="override-usage-hours"
            label="Override Hours"
            value={asset.override_hours}
            type="text"
            margin="normal"
            inputProps={{
              maxLength: 7,
            }}
            onChange={(e) => {
              dispatch({
                type: actions.OVERRIDE_HOURS,
                payload: e.target.value.replace(/[\D,-]/g, ''),
              });
            }}
          />
        </Grid>
      }

    </Grid>
  )
}
